import {
  CarModelStrip,
  extractData,
  getHomepageCarStrip,
  HomePageCarStrip,
} from "api"
import slugify from "common/bit/utils/slugify"
import { createContext, useContext, useEffect, useState } from "react"
import { LinksType } from "../common/SiteLinks"

export type GlobalContextType = {
  footerModelLinks: LinksType[]
  modelList: CarModelStrip[] | null
}

export const GlobalContext = createContext<GlobalContextType>(null)

type GlobalContextProps = {
  children?: React.ReactNode
}

export const GlobalContextProvider = ({ children }: GlobalContextProps) => {
  const [footerModelLinks, setFooterModelLinks] = useState<LinksType[]>([])
  const [modelList, setModelList] = useState<CarModelStrip[] | null>(null)

  const carLinkFunc = (modelData: HomePageCarStrip) => {
    if (!modelData) return "/"
    return `/model/[modelId]/[modelSlug]`
      .replace("[modelId]", modelData.id.toString())
      .replace("[modelSlug]", slugify(modelData.name))
  }

  useEffect(() => {
    let isComponentMounted = true
    const fetchData = async () => {
      if (isComponentMounted) {
        const data = await getHomepageCarStrip().then(extractData)
        if (data?.body) {
          // Set the model list from the API response
          setModelList(
            data?.body?.cars.map((car) => ({
              ...car,
              link: carLinkFunc(car),
            })) || []
          )
          const changesList = data?.body?.cars
            ?.filter((car) => car.carState !== "Future")
            .map((item: HomePageCarStrip) => ({
              title: item.name,
              link: carLinkFunc(item),
            }))
          setFooterModelLinks(changesList)
        }
      }
    }
    fetchData().catch(console.error)
    return () => {
      isComponentMounted = false
    }
  }, [])

  return (
    <GlobalContext.Provider
      value={{
        footerModelLinks,
        modelList,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export const useGlobalContext = () => useContext(GlobalContext)
